<template>
  <div class="operation-management">
    <!-- 作业头部按钮 -->
    <!-- <div class="management-header-btn">
    <el-button class="btn">返回</el-button>
  </div> -->
    <!--作业头部内容 -->

    <el-card>
      <div class="management-header-content">
        <!-- 第一行内容 -->
        <el-row :gutter="20">
          <!-- 课程名称 -->
          <el-col el-col :span="6">
            <div class="double-content">
              <div class="text">课程名称</div>
              <div class="main">
                <el-select filterable placeholder="课程名称" v-model="form.courseId" :clearable=true>
                  <el-option v-for="(item, index) in homeWorkData" :key="index" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-col>
          <!-- 课程分类 -->
          <el-col el-col :span="6">
            <div class="double-content">
              <div class="text">课程分类</div>
              <div class="main-lesson">
                <el-select filterable placeholder="全部" v-model="form.classifyTopId" :clearable=true>
                  <el-option v-for="(item, index) in classifyTopName" :key="index" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-col>

          <!-- 创建人 -->
          <el-col el-col :span="6">
            <div class="double-content">
              <div class="text">创建人</div>
              <div class="main">
                <el-input v-model="form.creatBy"></el-input>
              </div>
            </div>
          </el-col>

          <!-- 按钮 -->


            <div class="btn-body-left">
              <div style="padding: 0px;
                margin-left: 35px;
                color:#252628FF;
                font-size: 15px;
                margin-top: 3px;" type="text" cursor: pointer @click="moreList = !moreList" v-bind:class="{
                  'el-icon-arrow-up': moreList,
                  'el-icon-arrow-down': !moreList,
                }">
                &nbsp;<div style="margin: -15px 0 0 -35px;cursor: pointer;">{{ moreList ? "收起" : "展开" }}</div>
              </div>

              <div class="btn-all">
                <el-button class="reset-btn" @click="clear()">重置</el-button>
                <el-button v-if="checkSelect()" class="select-btn" @click="queryList()">查询</el-button>

              </div>
            </div>




        </el-row>




        <!-- 第二行内容 -->
        <el-row v-show="moreList" :gutter="20">
          <!-- 业务团队 -->
          <el-col el-col :span="6">
            <div class="double-content">
              <div class="text">业务团队</div>
              <div class="main">
                <el-select filterable placeholder="全部" v-model="form.teamType" :clearable=true>
                  <el-option v-for="(item, index) in team" :key="index" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-col>
          <!-- 课程开发培训师 -->
          <el-col el-col :span="6">
            <div class="double-content">
              <div class="text">课程开发培训师</div>
              <div class="main-text-trainer">
                <el-input v-model="form.trainerName"></el-input>
              </div>
            </div>
          </el-col>



        </el-row>

      </div>

    </el-card>


    <!-- 作业表单数据 -->
    <div class="management-main">

      <el-card class="newCL-third" style="border-right:none">
        <el-table :data="tableData" :border="false" tooltip-effect="light" v-loading="dataListLoading"
          @row-click="handleRow" :row-style="pointerStyle">

          <!-- <el-table-column
          type="index"
          show-overflow-tooltip
          label="序号"
          min-width="50"
          align="left"
        ></el-table-column> -->
          <!-- <el-table-column
        show-overflow-tooltip
          prop="courseCode"
          label="课程编号"
          min-width="110"
        ></el-table-column> -->
          <el-table-column show-overflow-tooltip prop="courseName" label="课程名称" min-width="110"></el-table-column>
          <el-table-column prop="teamTypeDesc" show-overflow-tooltip label="业务团队" min-width="50"></el-table-column>
          <el-table-column prop="topClassifyName" show-overflow-tooltip label="课程分类" min-width="50"></el-table-column>
          <el-table-column prop="trainnerNameCn" label="课程开发培训师" show-overflow-tooltip min-width="120">
          </el-table-column>
          <el-table-column show-overflow-tooltip min-width="80" prop="creatBy" label="创建人">
          </el-table-column>
          <el-table-column width="117px" height="52px" fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <!-- 查看 -->
              <div class="colum-right-style">
                <el-tooltip content="查看" placement="bottom" effect="light">
                  <span>
                    <div>
                      <img v-if="checkCheck()" @click="handleClick(scope.row)" src="@/assets/img/course/check@2x.png"
                        class="picIcon"  alt="" />

                    </div>
                  </span>
                </el-tooltip>
                <img v-if="!checkCheck()" @click.stop="handleClickStop(scope.row)"
                  src="@/assets/img/course/check_block@2x.png"  class="picIcon"  alt="" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <div class="pagination-select">
        <el-pagination :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit" :total="totalCount"
          layout="total,prev,pager,next,sizes,jumper" @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
        </el-pagination>
      </div>
    </div>
  </div>

</template>


<!-- scriptttttt -->
<script >
export default {
  data() {
    return {
      dataListLoading: false,
      page: 1,
      limit: 10,
      totalCount: 0,
      moreList: false,
      tableData: [],
      homeWorkData: [],
     team:[],
      form: {
       "courseId":"",
      "teamType":"",
      "classifyTopId":"",
      "creatBy":"",
      "trainerName": ""
      },
      // classifyTopName: this.enums["courseHomeCatalog"],
      classifyTopName:[],

    }
  },
  methods: {
    getListTeamParentType(){
      this.$request
        .post("/course/listTeamParentType")
        .then((res) => {
          this.team = res;
        })
        .catch((err) => {
          console.log(err);
        });

    },
    getAuthorizedTopClassifyMeta() {
    this.$request
      .post("/course/getAuthorizedTopClassifyMeta")
      .then((res) => {
        this.classifyTopName = res;
      })
      .catch((err) => {
        console.log(err);
      });
  },

    // 查询按钮权限
    checkSelect() {
      if (this.$hasPermission('joy:learning:courseoperation:select')) {
        return true
      }
      return false
    },
    // 查看按钮权限
    checkCheck() {
      if (this.$hasPermission('joy:learning:courseoperation:check')) {
        return true
      }
      return false
    },
    // 手
    pointerStyle() {
      return {
        cursor: "pointer",
        fontSize: "14px",
        fontFamily: "PingFang SC-Regular, ingFangSC-Regular, sans-serif",
        fontWeight: 400,
        color: "#252628"
      };
},
    // 表格行事件
    handleRow(row) {
      if (this.checkCheck()) {
        console.log(row, "row=========")
        this.$router.push({
          path: "/operationView",
          query: { show: JSON.stringify(row) },
        });
        this.$eventHub.$emit("show", row);
      }
    },
    // 重置数据
    clear() {
      this.form.courseId = ""
      this.form.teamType = ""
      this.form.classifyTopId = ""
      this.form.creatBy = ""
      this.form.trainerName = ""
      this.page=1;
      this.getData();
    },
    // 查询数据
    queryList() {
      this.page=1;
      this.getData();
    },
    // 分页, 每页条数
    pageSizeChangeHandle(val) {
      this.page = 1;
      this.limit = val;
      this.getData();
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.page = val;
      this.getData();
    },
    // 表单数据
    getData() {
      this.dataListLoading = true
      this.$request
        .post("/course/homework/selectHomeworkCourseList", {
          courseHomeworkSearchVO: {
            courseType: 1,
            courseId: this.form.courseId,
            teamType: this.form.teamType,
            classifyTopId: this.form.classifyTopId,
            creatBy: this.form.creatBy,
            trainerName: this.form.trainerName
          },
          ps: {
            pageNo: this.page,
            pageSize: this.limit,
          },
        })
        .then((res) => {
          this.dataListLoading = false
          this.tableData = res.data
          this.totalCount = res.totalCount
        });
    },
    fnHomeData(arr) {
      const res = new Map();
      return arr.filter(arr => !res.has(arr.courseName) && res.set(arr.courseName));
    },
    getHomeWorkData() {
      this.homeWorkData = [];
      this.$request
        .post("/course/homework/selectHomeworkCourseList", {
          courseHomeworkSearchVO: {
            courseType: 1,
          },
          ps: {
            pageNo: 1,
            pageSize: 999,
          },
        })
        .then((res) => {
          let data = res.data
          data=this.fnHomeData(data)
          data.map((item) => {
            this.homeWorkData.push({ value: item.courseId, label: item.courseName })
          })
        });
    },
    // 查看路由跳转
    handleClick(row) {
      console.log(row, "row=========")
      this.tabRemove(this.$store.state.contentTabsActiveName, row)
      this.$eventHub.$emit("show", row);
    },
    tabRemove(tabName, data) {
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          path: "/operationView",
          query: { show: JSON.stringify(data) },
        });
      }
    },
    handleClickStop() {
      console.log(0)
    }
  },
  created() {
    this.getListTeamParentType(),
    this.getAuthorizedTopClassifyMeta(),
    this.getData();
    this.getHomeWorkData()
  },
}

</script>


<!-- styleeeeeee -->
<style lang="scss" scoped>
.picIcon{
 cursor:pointer;
 margin-left: 5px;
 width: 20px!important;
}
.btn-body-left{
    float: right;
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin-top: 32px;
}
// 框圆角
.el-input__inner {
  border-radius: 4px !important;
}

// 分页器样式
.el-pagination {
  display: flex;
  float: right;
  padding: 8px 3px 21px 0;
  margin-right: 9px;

  .el-pagination__jump {
    margin-left: 1px !important;
  }

  .el-pager {
    display: flex;
    flex-direction: row;
    column-gap: 9px;

    .number.active {
      color: #ffffff !important;
      background: #1C69D4FF !important;
      border-radius: 2px !important;

    }

    .number {
      width: 30px;
      height: 29px;
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #DFE0E2;
    }
  }

  .btn-prev {
    height: 29px;
    background: #FFFFFF;
    border-radius: 1px;
    border: 1px solid #DFE0E2;
    margin-right: 10px;
    margin-left: 7px;
  }

  .btn-next {
    height: 29px;
    background: #FFFFFF;
    border-radius: 1px;
    border: 1px solid #DFE0E2;
    margin-right: 4px;
    margin-left: 10px;
  }

}

// 分页器
.operation-management {
  display: flex;
  flex-direction: column;
  row-gap: 18px;
  width: 100%;
  height: 100%;

  // 作业头部按钮开始
  .management-header-btn {
    width: 100%;
    height: 50px;
    background: #ffff;

    .btn {
      width: 76px;
      height: 32px;
      background: #1C69D4;
      color: #fff;
      border-radius: 4px !important;
      float: right;
      margin: 9px 12px 4px 0;
    }
  }

  // 作业头部按钮结束

  // 作业头部内容开始
  .management-header-content {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    row-gap: 11px;
    .main{
      width: 100%;
    }
    .main-lesson{
      width: 100%;
    }
    .main-text-trainer{
      width: 100%;
    }

    .el-range-input {
      background: none;
    }

    .double-content {
      display: flex;
      flex-direction: column;
      row-gap: 17px;
      .text {
        white-space: nowrap;
        display: flex;
        justify-content: flex-start;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
       font-weight: 400;
       color: #252628;
      }

      .el-date-picker {
        width: auto !important;
      }

      .main-text {
        width: 202px;
        height: 28px;
      }
    }

    // 按钮布局
    .btn-all {
      float: right;
    }

    .reset-btn {
      border-radius: 4px !important;
      width: 76px;
      height: 32px;
      background: #FFFFFF;
      color: #1C69D4;
      border: 1px solid #1C69D4;
    }

    .reset-btn:focus {
      background: #fff !important;
    }

    .select-btn {
      border-radius: 4px !important;
      width: 76px;
      height: 32px;
      background: #1C69D4;
      color: #fff;
    }
  }

  // 作业头部内容结束

  // 作业表单布局开始
  .management-main {
    .newCL-third {
      padding-bottom: 68px;

    }

    .pagination-select {
      margin: -82px 11px 0 0px;
    }
  }


}
</style>
<style lang="scss">
/* 表单头部颜色更改 */
.aui-wrapper .el-table th {
  background: #fafbff !important;
  border-right: 1px #dcdee3 solid
}
.operation-management {
  // 杂类样式
  .el-table {
    tr th,
    tr td {
      border-right: none !important;
    }
  }
}
</style>
